module.exports = __webpack_public_path__ + "static/man_set_4teen.b41bdd27.svg";